
import Vue from "vue";
import { Component } from "vue-property-decorator";
import TopNav from "./TopNav.vue";
import { SingularityUIState } from "@/store/modules/singularity";
import TopNavButton from "./TopNavButton.vue";
import { singularityStore } from "@/store/store";
import TopNavSave from "./TopNavSave.vue";
// import TopNavToggleMobile from "./TopNavToggleMobile.vue";
import TopNavPreviewMode from "./TopNavPreviewMode.vue";
import { uiStore } from "@/store/store";
import TopNavUndoRedo from "./TopNavUndoRedo.vue";
// import TopNavToggleZoom from "./TopNavToggleZoom.vue";

export type NavLink = {
  panelState?: {
    leftPanel?: SingularityUIState["singularityLeftPanel"];
    fullWidthPanel?: SingularityUIState["singularityFullWidthPanel"];
    rightPanel?: SingularityUIState["singularityRightPanel"];
  };
  name: string;
  action?: () => void;
};

@Component({
  components: {
    TopNav,
    TopNavButton,
    TopNavSave,
    // TopNavToggleMobile,
    TopNavPreviewMode,
    TopNavUndoRedo,
    // TopNavToggleZoom
  }
})
export default class TopNavBuilder extends Vue {
  primaryNav: NavLink[] = [
    { panelState: { leftPanel: "page_structure", fullWidthPanel: null }, name: "Build" },
    { panelState: { leftPanel: "brand", fullWidthPanel: null }, name: "Brand" },
    { panelState: { leftPanel: "page_manager", fullWidthPanel: null }, name: "Pages" }
  ];

  get singularityDebugPanelOpen() {
    return (
      singularityStore.singularityUiState.singularityRightPanel === "debug"
    );
  }

  get unsavedChangesPresent() {
    return uiStore.unsavedChangesPresent;
  }

  get singularityUiState() {
    return singularityStore.singularityUiState;
  }

  get isFullWidthState() {
    return !!this.singularityUiState.singularityFullWidthPanel;
  }

  get isPageStructureOrBrandPanelOpen() {
    return (
      singularityStore.singularityUiState.singularityLeftPanel ===
        "page_structure" ||
      singularityStore.singularityUiState.singularityLeftPanel === "brand"
    );
  }

  openPageStructure() {
    singularityStore.setSingularityLeftPanel("page_structure");
  }
}
